/**
 * @param {string|string[]|Object} value - The string value of a prop or responsive array of the props, or an object with responsive keys
 * @param {string} value[0] - Value at xs screen-size and up
 * @param {string} value[1] - Value at sm screen-size and up
 * @param {string} value[2] - Value at md screen-size and up
 * @param {string} value[3] - Value at lg screen-size and up
 * @param {string} value[4] - Value at xl screen-size and up
 * @param {Object} value - An object with responsive arrays
 * @param {string} value.xs - Value at xs screen-size and up
 * @param {string} value.sm - Value at sm screen-size and up
 * @param {string} value.md - Value at md screen-size and up
 * @param {string} value.lg - Value at lg screen-size and up
 * @param {string} value.xl - Value at xl screen-size and up
 * @param {string} propName - The name of the prop
 * @returns An object with style properties
 *
 * @example
 * makeResponsive('space-around', 'justify-content')
 * makeResponsive({ sm: 'space-between', md: 'space-around' }, 'justify-content')
 * makeResponsive([ undefined, 'space-between', 'space-around' ], 'justify-content')
 */
var getPropertyKey = function getPropertyKey(propName, breakpoint) {
  if (breakpoint === void 0) {
    breakpoint = '';
  }

  return "--" + breakpoint + propName;
};

var makeResponsive = function makeResponsive(value, propName) {
  if (typeof value === 'string') {
    var _ref;

    return _ref = {}, _ref[getPropertyKey(propName)] = value, _ref;
  }

  if (Array.isArray(value)) {
    var _ref2;

    return _ref2 = {}, _ref2[getPropertyKey(propName)] = value[0], _ref2[getPropertyKey(propName, 'sm-')] = value[1], _ref2[getPropertyKey(propName, 'md-')] = value[2], _ref2[getPropertyKey(propName, 'lg-')] = value[3], _ref2[getPropertyKey(propName, 'xl-')] = value[4], _ref2;
  }

  if (typeof value === 'object') {
    var _ref3;

    return _ref3 = {}, _ref3[getPropertyKey(propName)] = value.xs, _ref3[getPropertyKey(propName, 'sm-')] = value.sm, _ref3[getPropertyKey(propName, 'md-')] = value.md, _ref3[getPropertyKey(propName, 'lg-')] = value.lg, _ref3[getPropertyKey(propName, 'xl-')] = value.xl, _ref3;
  }

  return {// [getPropertyKey(propName)]: 'initial',
    // [getPropertyKey(propName, 'sm-')]: 'initial',
    // [getPropertyKey(propName, 'md-')]: 'initial',
    // [getPropertyKey(propName, 'lg-')]: 'initial',
    // [getPropertyKey(propName, 'xl-')]: 'initial',
  };
};

export default makeResponsive;